import Layout from "../../components/layOutWrapper/layOutWrapper";
import VehicleForm from "../../components/vehicles/addVehicleForm";

export default function AddVehicleFormView () {
    return (
        <>
            <Layout children={<VehicleForm/>} sectionTitle="Agregar un vehículo al sistema"/>
        </>
    )
}